const DISCOVERY_BASE_URL = window.env?.DISCOVERY_URL || 'https://discovery.ms.pactosolucoes.com.br';

export const findServiceUrlsGlobal = async () => {
  try {
    const response = await fetch(`${DISCOVERY_BASE_URL}/find`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const data = await response.json();
      const serviceUrls = data?.content?.serviceUrls;

      if (serviceUrls) {
        return {
          success: true,
          serviceUrls,
          fullContent: data.content
        };
      } else {
        return {
          success: false,
          error: 'URLs dos serviços não encontradas na resposta'
        };
      }
    } else {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.message || errorData?.content?.message || `Erro ao buscar serviços: ${response.status}`
      };
    }
  } catch (error) {
    return {
      success: false,
      error: `Erro de conexão com o Discovery Service: ${error.message}`
    };
  }
};

export const findServiceUrls = async (chave) => {
  if (!chave || chave.trim() === '') {
    return {
      success: false,
      error: 'Chave é obrigatória para buscar as URLs dos serviços'
    };
  }

  try {
    const response = await fetch(`${DISCOVERY_BASE_URL}/find/${chave}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const data = await response.json();
      const serviceUrls = data?.content?.serviceUrls;

      if (serviceUrls) {
        return {
          success: true,
          serviceUrls,
          fullContent: data.content
        };
      } else {
        return {
          success: false,
          error: 'URLs dos serviços não encontradas na resposta'
        };
      }
    } else {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.message || errorData?.content?.message || `Erro ao buscar serviços: ${response.status}`
      };
    }
  } catch (error) {
    return {
      success: false,
      error: 'Erro de conexão com o serviço de discovery. Verifique se o serviço está disponível.'
    };
  }
};

export const getAuthServiceUrl = async (chave) => {
  const result = await findServiceUrls(chave);

  if (result.success) {
    const authUrl = result.serviceUrls.loginAppUrl;

    if (authUrl) {
      return {
        success: true,
        url: authUrl,
        isSecureLogin: !!result.serviceUrls.loginAppUrl
      };
    } else {
      return {
        success: false,
        error: 'URL do serviço de autenticação não encontrada'
      };
    }
  }

  return result;
};

export const getValidationServiceUrl = async (chave) => {
  const result = await findServiceUrls(chave);
  
  if (result.success) {
    const validationUrl = result.serviceUrls.zwBack;
    
    if (validationUrl) {
      return { success: true, url: validationUrl };
    } else {
      return { 
        success: false, 
        error: 'URL do serviço de validação não encontrada' 
      };
    }
  }
  
  return result;
};

export const cacheServiceUrls = (serviceUrls) => {
  localStorage.setItem('pacto_service_urls', JSON.stringify(serviceUrls));
};

export const getCachedServiceUrls = () => {
  const cached = localStorage.getItem('pacto_service_urls');
  return cached ? JSON.parse(cached) : null;
};

export const clearServiceUrlsCache = () => {
  localStorage.removeItem('pacto_service_urls');
};

